module.exports = __webpack_public_path__ + "img/pleasure-icon-3.c350442c.svg";